import { useEffect, useState } from 'react';
import { Instagram, Facebook, Linkedin, Youtube, Twitter, Globe, MessageCircle, Music2 } from 'lucide-react';
import { api } from '@/lib/api';

let cache = null;

export const useLanding = () => {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get('/public/landing').then(({ data: d }) => { cache = d; setData(d); }).catch(() => setData({ testimonials: [], tutorials: [], social_links: [] }));
  }, []);
  return data;
};

export const SOCIALS = [
  { key: 'instagram', label: 'Instagram', Icon: Instagram },
  { key: 'facebook', label: 'Facebook', Icon: Facebook },
  { key: 'linkedin', label: 'LinkedIn', Icon: Linkedin },
  { key: 'youtube', label: 'YouTube', Icon: Youtube },
  { key: 'tiktok', label: 'TikTok', Icon: Music2 },
  { key: 'x', label: 'X / Twitter', Icon: Twitter },
  { key: 'whatsapp', label: 'WhatsApp', Icon: MessageCircle },
  { key: 'other', label: 'Lainnya', Icon: Globe },
];

export const socialIcon = (platform) => (SOCIALS.find((s) => s.key === platform) || SOCIALS[SOCIALS.length - 1]).Icon;

export const waLink = (phone) => `https://wa.me/${String(phone || '').replace(/[^0-9]/g, '')}`;

export const youtubeEmbed = (url) => {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{6,})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
};

export const MODULE_SHOTS = [
  { key: 'apps', title: 'Satu beranda, semua modul', desc: 'Pasang hanya modul yang Anda butuhkan — CRM, Sales, Inventory, Akuntansi, HR, Website, Diskusi, Dokumen — dan semuanya saling terhubung dalam satu data perusahaan.', img: '/screenshots/apps.jpg' },
  { key: 'accounting', title: 'Akuntansi yang menjurnal sendiri', desc: 'Setiap penjualan, penerimaan barang, penyusutan aset, hingga payroll langsung menjadi jurnal. Neraca, laba rugi, dan neraca saldo selalu seimbang tanpa input ganda.', img: '/screenshots/accounting.jpg' },
  { key: 'hr', title: 'HR & Payroll ala Indonesia', desc: 'Absensi wajah + GPS geofence lewat kiosk tablet atau HP karyawan, cuti, reimbursement, dan payroll dengan BPJS serta PPh 21 metode TER yang otomatis diposting ke akun gaji.', img: '/screenshots/hr.jpg' },
  { key: 'sales', title: 'Dari prospek sampai lunas', desc: 'Pipeline CRM, penawaran, sales order, pengiriman stok, invoice PPN 11%, dan pencatatan pembayaran dalam satu alur tanpa perpindahan aplikasi.', img: '/screenshots/sales.jpg' },
  { key: 'website', title: 'Website dua bahasa dengan AI', desc: 'Bangun website perusahaan ID/EN dalam hitungan menit, unggah gambar & logo, lalu hubungkan domain sendiri dengan SSL otomatis.', img: '/screenshots/website.jpg' },
  { key: 'discuss', title: 'Kolaborasi tim di tempat kerja', desc: 'Channel, grup privat, pesan langsung, mention, dan lampiran — percakapan tim tersimpan bersama data bisnisnya.', img: '/screenshots/discuss.jpg' },
];
